export const calendarModals = {
  common: {
    cancel: "Cancel",
  },
  arrival: {
    title: "Calendar rules",
    loading: "Loading settings…",
    daysTitle: "Arrival and departure days",
    canArrive: "Guests can arrive",
    canDepart: "Guests can leave",
    daysHint:
      "With <b>all selected</b> there are no restrictions. If you only allow arrivals on Monday and departures on Sunday, every booking will last exactly one week.",
    summaryAny: "Guests can arrive and leave any day",
    summaryArrival: "arrival on {n} of 7 days",
    summaryDeparture: "departure on {n} of 7 days",
    summaryRestricted: "Restricted: {detail}",
    cutoffTitle: "Close today's sales after a set time",
    cutoffToggle: "Automatically close same-day sales",
    cutoffToggleHint: "While this is off, you accept check-ins for today at any time.",
    cutoffFrom: "From",
    cutoffTz: "your property's time",
    cutoffTzNow: "there it's {time}",
    cutoffHintPre: "Every day, at ",
    cutoffHintMid: " in ",
    cutoffHintPost:
      ", you'll stop receiving bookings for that same day. The following days stay open as usual.",
    cutoffSummaryOn: "Sales close every day at {time}",
    cutoffSummaryOff: "You accept check-ins for today at any time",
    turnoverTitle: "Preparation time",
    turnoverQuestion: "How many nights do you need between one guest and the next?",
    turnoverOptNone: "None",
    nights: "{count} night | {count} nights",
    custom: "Custom",
    customLabel: "Nights",
    customAside: "on each side, up to 7",
    turnoverSummaryNone: "Guests can arrive the same day another leaves",
    turnoverSummarySet: "Keep {nights} between one guest and the next",
    turnoverLegacySummaryAfter: "Currently applies only after check-out · save to cover both sides",
    turnoverLegacySummaryBefore: "Currently applies only before check-in · save to cover both sides",
    turnoverLegacyNoteAfter: "This rule comes from the previous version and currently only blocks after check-out, not before check-in. Saving applies it to both sides, and we'll first show you how many nights will close.",
    turnoverLegacyNoteBefore: "This rule comes from the previous version and currently only blocks before check-in, not after check-out. Saving applies it to both sides, and we'll first show you how many nights will close.",
    exampleLabel: "Example",
    exampleCaption: "A booking arriving on the 15th and leaving on the 18th",
    legendStay: "Stay",
    legendPrep: "Preparation",
    legendFree: "On sale",
    turnoverMoveHint:
      "The block moves on its own if the dates change and disappears if the booking is cancelled.",
    impactClosePre: "This will close ",
    impactClosePost: " in your channels.",
    impactOpenPre: "This will open ",
    impactOpenPost: ".",
    impactRetry: "Press “Save rules” again to apply it.",
    fallbackHost: "your property",
    saving: "Saving…",
    applyYes: "Yes, apply",
    saveRules: "Save rules",
    loadError: "The settings could not be loaded.",
    saveSuccess: "Calendar rules saved and sent to your channels.",
    saveError: "Could not save.",
    saveConfigError: "The settings could not be saved.",
    linkedTitle: "Whole-apartment sales",
    linkedSummaryOff: "This unit is sold on its own",
    linkedSummaryOn: "Sells the whole place · includes {count} room | Sells the whole place · includes {count} rooms",
    linkedSummaryChild: "Part of {parent}",
    linkedRooms: "{count} room | {count} rooms",
    linkedToggle: "Set as the listing's whole apartment",
    linkedToggleHint: "For the unit that rents out the entire place. Next, choose which rooms it includes.",
    linkedQuestion: "Which rooms does it include?",
    linkedAll: "Select all",
    linkedNone: "Clear all",
    linkedIsParent: "Already sold as a whole apartment",
    linkedGuests: "{count} guest | {count} guests",
    linkedExampleCaption: "«{room}» is booked from the 19th to the 21st",
    linkedExampleRoom: "Room 1",
    linkedLegendClosed: "Closes automatically",
    linkedHint: "It works the other way too: if the whole apartment is booked, all its rooms close. If the booking is cancelled or its dates change, everything reopens on its own, on your channels too. While the booking stands, these closures can't be opened by hand.",
    linkedChildPre: "This room is part of ",
    linkedChildPost: ". When it's booked, that whole apartment closes for those nights; when the whole apartment is booked, this room closes on its own. You can change this from the whole apartment's calendar rules.",
    linkedConflicts: "There is already {count} double booking between the whole apartment and its rooms. Review it: | There are already {count} double bookings between the whole apartment and its rooms. Review them:",
    linkedNeedsRooms: "Select at least one room included in the whole apartment.",
    linkedSaveError: "The whole-apartment settings could not be saved.",
    linkedAlertTitle: "«{unit}» becomes the whole apartment",
    linkedAlertBody: "If it's booked, the rooms you select will close automatically, here and on your channels (Booking, Airbnb…). And if any of those rooms is booked, this unit will close for those nights. If the booking is cancelled, everything reopens on its own.",
    linkedPartialSave: "The whole-apartment setting was saved, but the other rules weren't. Please try again.",
  },
  weekend: {
    title: "Price settings",
    subtitle: "This information will show every night, unless you customise it by date.",
    loading: "Loading settings…",
    plTitle: "Prices managed by PriceLabs",
    plDesc1:
      "This property has dynamic price management active with PriceLabs. Prices update automatically based on demand, season and occupancy.",
    plDesc2: "To change weekend prices, do it directly from your PriceLabs panel.",
    plOpen: "Open PriceLabs",
    basePriceTitle: "Base price",
    basePriceLabel: "Per night — applied every day",
    customization: "Customisation",
    weekendPriceTitle: "Weekend price",
    toggleOff: "Disable weekend price",
    toggleOn: "Enable weekend price",
    appliesTo: "Applies on:",
    weekendLabel: "Weekend",
    infoHint: "It will apply to the next <strong>500 days</strong> on the selected days.",
    disabledText: "Weekend days will use the base price of",
    confirmTitle: "Disable weekend price?",
    confirmDescPre: "The days will return to the base price of",
    confirmDescPost: "automatically.",
    disabling: "Disabling…",
    confirmDisable: "Yes, disable",
    saving: "Saving…",
    saveChanges: "Save changes",
    diffEqual: "same as base",
    diffUp: "+{pct}% vs base",
    diffDown: "{pct}% vs base",
    loadError: "Error loading the price settings",
    disableSuccess: "Weekend price disabled. The days return to the base price.",
    disableError: "Error disabling the weekend price",
    saveSuccess: "Prices saved successfully",
    saveError: "Error saving",
  },
};
